import { useQuery } from "@tanstack/react-query"
import { locationService } from "../../services/locationService"
import { useContext, useEffect, useState } from "react"
import UiContext from "../../context/uiProvider"
import { DESKTOP, TABLET } from "../../utils/screenSize"
import Table from "./common/Table"

export default function OrganizationLocationsTable({ organizationId }: { organizationId: number }) {
  const { deviceView } = useContext(UiContext)
  const [currentPage, setCurrentPage] = useState(1)
  const [limit, setLimit] = useState(10) // can be changed to a user setting later
  const [totalLocations, setTotalLocations] = useState(0)
  const [searchTerm, setSearchTerm] = useState<string>("")

  const { data, isLoading } = useQuery(
    ["locations", "organizationId" + organizationId, limit, currentPage, searchTerm],
    () => locationService.getSomeByOrganization(organizationId, limit, currentPage - 1, searchTerm),
    {
      cacheTime: 5000,
      enabled: !!organizationId
    }
  )

  const [filteredData, setFilteredData] = useState<any[]>([])

  useEffect(() => {
    if (data) {
      setFilteredData(data.locations || [])
      setTotalLocations(data.totalCount || 0)
    }
  }, [data])

  useEffect(() => {
    setCurrentPage(1)
  }, [limit])

  const headers: { label: string, key: string, to?: string }[] = [
    { label: "Id", key: "id", to: `/app/locations` },
    { label: "Name", key: "name", to: `/app/locations` },
  ]

  // Add two more columns on tablets and desktops
  if (deviceView >= TABLET) {
    headers.push({ label: "Address", key: "address" }, { label: "City", key: "city" }, { label: "State", key: "state" }, { label: "Zipcode", key: "zipcode" })
  }
  // Add two additional columns on desktops
  if (deviceView >= DESKTOP) {
    headers.push({ label: "Latitude", key: "latitude" }, { label: "Longitude", key: "longitude" })
  }

  function handleSearch(query: string) {
    setCurrentPage(1)
    setSearchTerm(query)
  }

  if (isLoading) return null

  return (
    <Table
      data={filteredData}
      title={"Area Locations"}
      to="/app/addLocation"
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      setLimit={setLimit}
      handleSearch={handleSearch}
      headers={headers}
      totalCount={totalLocations}
      setTotalCount={setTotalLocations}
    />
  )
}
